module.exports = __webpack_public_path__ + "static/media/whatsapp1.2b826786.svg";